import { sendRequest } from "./requestTool"
const mockDelay = 2000

export const getObjects = function () {
  console.log("objects request")
  const mock = true
  return new Promise((resolve, reject) => {
    if (mock) {
      resolve({
        data: [
          {
            id: 0,
            name: "salon name 1",
            address: "Okopowa 14a",
            openingHours: {
              hours: 9,
              minutes: 0,
            },
            closingHours: {
              hours: 17,
              minutes: 0,
            },
            phoneNumber: "string",
            fileIds: [0],
          },
          {
            id: 1,
            name: "mock name 2",
            address: "Sokratesa 5",
            openingHours: {
              hours: 10,
              minutes: 0,
            },
            closingHours: {
              hours: 18,
              minutes: 0,
            },
            phoneNumber: "string",
            fileIds: [1],
          },
        ],
      })
    } else {
      sendRequest({
        url: "http://spoomyfly.com/api/WorkObject/GetObjects",
      })
        .then(res => {
          resolve(res)
        })
        .catch(err => {})
    }
  })
}

export const getServices = function () {
  console.log("services request")
  const mock = true
  return new Promise((resolve, reject) => {
    if (mock) {
      resolve({
        data: [
          {
            name: "strzyzenie",
            serviceTimeInterval: {
              ticks: 0,
              days: 0,
              hours: 0,
              milliseconds: 0,
              minutes: 0,
              seconds: 0,
              totalDays: 0,
              totalHours: 0,
              totalMilliseconds: 0,
              totalMinutes: 0,
              totalSeconds: 0,
            },
            servicePrice: 0,
            description: "to wtedy jak ktos kogos strzyze",
            fileIds: [0],
          },
          {
            name: "farbowanie",
            serviceTimeInterval: {
              ticks: 0,
              days: 0,
              hours: 0,
              milliseconds: 0,
              minutes: 0,
              seconds: 0,
              totalDays: 0,
              totalHours: 0,
              totalMilliseconds: 0,
              totalMinutes: 0,
              totalSeconds: 0,
            },
            servicePrice: 0,
            description: "to wtedy jak ktos kogos farbuje",
            fileIds: [0],
          },
        ],
      })
    } else {
      sendRequest({
        url: "http://spoomyfly.com/api/WorkObject/GetObjects",
      })
        .then(res => {
          resolve(res)
        })
        .catch(err => {})
    }
  })
}

export const getReservations = function (date) {
  const mock = true
  console.log("reservations request")

  return new Promise((resolve, reject) => {
    if (mock) {
      setTimeout(() => {
        resolve({
          data: {
            date: date,
            reservations: [
              {
                workPoint: {
                  id: 0,
                  shortInfo: "string",
                  workersInfo: [
                    {
                      id: 0,
                      shortInfo: "string",
                      services: [
                        {
                          id: 0,
                          shortInfo: "strzyzenie",
                          interval: {
                            hours: 0,
                            minutes: 30,
                          },
                        },
                      ],
                      busyTimeRanges: [
                        {
                          startTime: {
                            hours: 10,
                            minutes: 0,
                          },
                          finishTime: {
                            hours: 10,
                            minutes: 40,
                          },
                        },
                      ],
                    },
                  ],
                  closingHours: {
                    hours: 18,
                    minutes: 0,
                  },
                  openingHours: {
                    hours: 9,
                    minutes: 0,
                  },
                },
                from: {
                  hours: 0,
                  minutes: 0,
                },
                to: {
                  hours: 0,
                  minutes: 0,
                },
              },
            ],
          },
        })
      }, mockDelay)
    } else {
      sendRequest({
        url: "http://spoomyfly.com/api/WorkObject/GetObjects",
      })
        .then(res => {
          resolve(res)
        })
        .catch(err => {})
    }
  })
}
